// extracted by mini-css-extract-plugin
export default {"blockTitle":"ExaminationResult_blockTitle__LTmaN","points":"ExaminationResult_points__mYf4Y"};